import axios from "axios";

// In the browser, always talk to the API on the domain the page was served from
// (custom domain + emergent.host both serve the same backend). Falls back to env.
const ORIGIN =
  typeof window !== "undefined" && /^https?:/.test(window.location.origin)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${ORIGIN}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ba30_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
